// useProductData.ts
import { useQuery } from '@tanstack/react-query';
import { getSheetData } from '@/app/actions/google-sheets.action';
// import getLinks from '@/app/actions/images/get-links.action';

const fetchSpreadsheetData = async () => {
  // Сначала обновляем ссылки на изображения
  // try {
  //   await getLinks();
  //   console.log('Image links updated successfully');
  // } catch (error) {
  //   console.error('Failed to update image links:', error);
  // }

  // Затем получаем актуальные данные
  return await getSheetData();
};

export const useProductData = () => {
  return useQuery({
    queryKey: ['spreadsheetData'],
    queryFn: fetchSpreadsheetData,
    staleTime: 30 * (60 * 1000), // данные считаются свежими 30 минут
    refetchOnMount: true, // обновлять при монтировании компонента
  });
};
